// Polyfill for findDOMNode to support MUI v4 with React 19
import ReactDOMModule from 'react-dom';
if (!ReactDOMModule.findDOMNode) {
  const findDOMNode = (instance) => {
    if (instance?.nodeType) return instance;
    if (instance && instance._reactInternalFiber) {
      let fiber = instance._reactInternalFiber;
      while (fiber && !fiber.stateNode?.nodeType) fiber = fiber.child;
      return fiber?.stateNode || null;
    }
    if (instance && instance._reactInternals) {
      let fiber = instance._reactInternals;
      while (fiber && !fiber.stateNode?.nodeType) fiber = fiber.child;
      return fiber?.stateNode || null;
    }
    return null;
  };
  ReactDOMModule.findDOMNode = findDOMNode;
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App.jsx';
import queryString from 'query-string';

// Google Fonts: own file so @import is not merged after Sass @use (PostCSS order). Must load before app CSS.
import './shared/fonts/googleFonts.css';

// Bootstrap CSS is loaded via CDN in Html.jsx (Bootstrap 4.6.0). Do NOT import
// bootstrap@5 here — its wider `.container` max-width (1320px at xxl) overrides
// the CDN BS4 styles and breaks page layouts that rely on the 1140px BS4 container.
import 'bootstrap-icons/font/bootstrap-icons.css';

// AG Grid base + alpine theme + custom overrides (imported once globally,
// since Vite ignores SCSS files imported from /public/).
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './styles/ag-theme-alpine-via.scss';

import router from './router';
import { setRouteResolver } from './components/RouteResolver.jsx';

// Mocks for the existing legacy context expected by App.js
const context = {
    insertCss: (...styles) => {
        const removeCss = styles.map(x => x._insertCss());
        return () => {
            removeCss.forEach(f => f());
        };
    },
    fetch: window.fetch.bind(window),
    pathname: window.location.pathname,
    query: {},
};

let currentRoute = null;
let root = null;

async function init() {
    try {
        const route = await router.resolve(context);

        if (route.redirect) {
            window.location.assign(route.redirect);
            return;
        }

        currentRoute = route;

        root = ReactDOM.createRoot(document.getElementById('app'));

        // Initialize RouteResolver with global router and context
        setRouteResolver(router, context, root);

        root.render(
            <App context={context}>
                {route.component}
            </App>
        );

        // Note: history listener not needed anymore as RouteResolver handles location changes
        
    } catch (error) {
        console.error('Client-side navigation error:', error);
    }
}

init();